<template>
  <div class="ibox">

    <a class="ibox-results-collapse visible-xs" role="button" data-toggle="collapse" href=".ibox-results-filters-collapse-box" aria-expanded="false" aria-controls="ibox-results-filters-collapse-box">
      Show Filters <i class="fa fa-bars"></i>
    </a>
    <div class="ibox-results-filters-collapse-box collapse in">
      <div class="ibox-results-filters">
        <div class="row">
          <div class="col-sm-6 col-lg-3" v-if="$user.isAdminOrCoordinator">
            <div class="form-group">
              <label class="control-label">Carrier</label>
              <selectize :options="initialUserOptions" v-model="carrier_id" name="user" :fetch-results="fetchUserResults"></selectize>
            </div>
          </div>
          <div class="col-sm-6 col-lg-2">
            <div class="form-group">
              <label class="control-label">Payment Number</label>
              <input type="text" class="form-control" placeholder="#12345" @input="updateNumber"/>
            </div>
          </div>
          <div class="col-sm-6 col-lg-2">
            <div class="form-group">
              <label class="control-label">Payment Low</label>
              <div class="input-group">
                <span class="input-group-addon">$</span>
                <input type="number" class="form-control" min="0" placeholder="0.00" @input="updateLow" />
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-lg-2">
            <div class="form-group">
              <label class="control-label">Payment High</label>
              <div class="input-group">
                <span class="input-group-addon">$</span>
                <input type="number" class="form-control" min="0" placeholder="0.00" @input="updateHigh"/>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-lg-3">
            <div class="form-group">
              <label class="control-label">Date Range</label>
              <date-range v-model="dateRange" name="date_range"></date-range>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="ibox-content">
      <ul class="list-detail list-detail-payment">
        <payment-item v-for="payment in payments" :key="payment.id" :payment="payment"></payment-item>
      </ul>
      <div class="text-center text-muted" v-show="haveNoPayments">
        <strong>There are no payments.</strong>
      </div>
    </div>

    <lazy-loading v-show="havePayments" :reached-bottom="getPaymentsForNextPage" :filters="filters" ref="lazyLoading">
      <strong slot="finished" class="text-muted">There are no more payments.</strong>
    </lazy-loading>
  </div>
</template>

<script>
  import { LazyLoading } from 'components/misc'
  import { debounce, isEqual, cloneDeep } from 'lodash'
  import { mapActions, mapGetters, mapState } from 'vuex'
  import { Roles } from 'utils/user'
  import { Selectize, DateRange } from 'components/forms'
  import PaymentItem from './PaymentItem'

  export default {
    components: {
      LazyLoading,
      PaymentItem,
      Selectize,
      DateRange
    },

    data () {
      return {
        initialUserOptions: [],
        carrier_id: null,
        high: null,
        low: null,
        number: '',
        dateRange: {
          from: null,
          to: null
        }
      }
    },

    watch: {
      filters: {
        handler (newFilters, oldFilters) {
          if (isEqual(newFilters, oldFilters)) {
            return
          }

          // Reset the lazy loading component so that it will attempt to load
          // more jobs as we scroll again.
          const resetLazyLoading = () => (this.$refs.lazyLoading.$emit('reset'))

          this.getPayments(this.filters).then(resetLazyLoading)
        },
        deep: true
      }
    },

    computed: {
      ...mapState('payment', ['payments']),
      ...mapGetters('user', ['userOptionsWithAll']),

      filters () {
        return {
          number: this.number,
          low: this.low,
          high: this.high,
          from: this.dateRange.from,
          to: this.dateRange.to,
          carrier_id: this.carrier_id
        }
      },

      havePayments () {
        return this.payments.length > 0
      },

      haveNoPayments () {
        return this.payments.length === 0
      }
    },

    created () {
      this.getPayments(this.filters)

      if (this.$user.isAdminOrCoordinator) {
        const setInitialUserOptions = () => (this.initialUserOptions = cloneDeep(this.userOptionsWithAll))

        this.getUsers({ roles: [Roles.CARRIER], master: true }).then(setInitialUserOptions)

        if (this.$route.query.user) {
          this.carrier_id = this.$route.query.user
        }
      }
    },

    methods: {
      ...mapActions('payment', ['getPayments', 'getPaymentsForNextPage']),
      ...mapActions('user', ['getUsers']),

      /**
       * When admin types in the user select box we need to fetch more users
       * from the api since the users are paginated.
       */
      fetchUserResults (name, callback) {
        return this.getUsers({ roles: [Roles.CARRIER], name, master: true }).then(response => {
          callback(this.userOptionsWithAll)
        })
      },

      /**
       * Debounce updating of number so we don't poll API immediately for new payments.
       *
       * @param object event
       *
       * @return Function
       */
      updateNumber: debounce(function (event) {
        this.number = event.target.value
      }, 800),

      /**
       * Debounce updating of low so we don't poll API immediately for new payments.
       *
       * @param object event
       *
       * @return Function
       */
      updateLow: debounce(function (event) {
        this.low = event.target.value
      }, 800),

      /**
       * Debounce updating of high so we don't poll API immediately for new payments.
       *
       * @param object event
       *
       * @return Function
       */
      updateHigh: debounce(function (event) {
        this.high = event.target.value
      }, 800)
    }
  }
</script>



// WEBPACK FOOTER //
// Payments.vue?71818690